import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ErrorMessage } from '../common/ErrorMessage';
import ProgramSection from './ProgramSection';

function ProgramSectionContainer(props) {
  const {
    verifyOnClick,
    apiResponse,
    apiError,
    isEnrolled,
    userId,
    customerAccountId,
  } = props;

  return (
    <Grid container xs={12}>
      {apiError && <ErrorMessage />}
      {!apiError && apiResponse && (
        <ProgramSection
          customerAccountId={customerAccountId}
          userId={userId}
          apiResponse={apiResponse}
          isEnrolled={isEnrolled}
          verifyOnClick={verifyOnClick}
        />
      )}
    </Grid>
  );
}

ProgramSectionContainer.propTypes = {
  verifyOnClick: PropTypes.func,
  customerAccountId: PropTypes.string,
  userId: PropTypes.string,
  isEnrolled: PropTypes.bool,

  apiResponse: PropTypes.objectOf(PropTypes.any),
  apiError: PropTypes.shape({
    showRedirectAlert: PropTypes.bool,
  }),
};
ProgramSectionContainer.defaultProps = {
  verifyOnClick: () => {},
  isEnrolled: false,
  apiResponse: null,
  apiError: false,
};

export default ProgramSectionContainer;
